<template>
  <g>
    <path
      d="M6.49989 5.96428L1.67248 10.7917C1.40999 11.0542 0.961183 10.8683 0.961183 10.4971L0.961182 0.842247C0.961182 0.471036 1.40999 0.285132 1.67248 0.547618L6.49989 5.37503C6.66261 5.53775 6.66261 5.80157 6.49989 5.96428Z"
      fill="#1C1C1E"
    />
    <path
      d="M6.49989 5.96428L1.67248 10.7917C1.40999 11.0542 0.961183 10.8683 0.961183 10.4971L0.961182 0.842247C0.961182 0.471036 1.40999 0.285132 1.67248 0.547618L6.49989 5.37503C6.66261 5.53775 6.66261 5.80157 6.49989 5.96428Z"
      fill="black"
      fill-opacity="0.2"
    />
  </g>
</template>
